// extracted by mini-css-extract-plugin
export default {"fullAlbumNewContainer":"album-new_fullAlbumNewContainer__vxeoD","headerRow":"album-new_headerRow__vJ90F","title":"album-new_title__CJxsr","step":"album-new_step__Ef4CB"};